import React, { Component,createRef, Fragment } from 'react';
import Nouislider from 'nouislider-react';
import "nouislider/distribute/nouislider.css";

import './index.sass';


class RangeSlider extends Component {
  constructor(props) {
    super(props);
    // 1. Створюємо реф для пошуку повзунків у DOM
    this.sliderWrapperRef = createRef();
  }

  state = {
    activeInput: '',
    employeeMax: Math.round(this.props.value.max / 15),
    employeeMin: Math.round(this.props.value.min / 15),
    maxInput: 0,
    minInput: 0,
    maxInputIsFocused: false,
    textValue: null,
    percent: null,
  };

  componentDidMount() {
    this.setState({
      minInput: this.props.value.min,
      maxInput: this.props.value.max,
    });
    // 2. Додаємо ARIA-атрибути під час монтування
    this.addAriaLabelsToHandles();
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.value.min !== prevProps.value.min || this.props.value.max !== prevProps.value.max) {
      this.setState({
        minInput: this.props.value.min,
        maxInput: this.props.value.max,
        employeeMin: Math.round(this.props.value.min / 15),
        employeeMax: Math.round(this.props.value.max / 15),
      });
    }
    // 3. Перевіряємо та додаємо ARIA-атрибути після кожного оновлення
    this.addAriaLabelsToHandles();
  };

  // 4. Функція для ін'єкції доступних імен безпосередньо в DOM слайдера
  addAriaLabelsToHandles = () => {
    if (this.sliderWrapperRef.current) {
      const lowerHandle = this.sliderWrapperRef.current.querySelector('.noUi-handle-lower');
      const upperHandle = this.sliderWrapperRef.current.querySelector('.noUi-handle-upper');

      // Використовуємо I18n для локалізації, якщо потрібно, або залишаємо дефолтні значення
      const fromLabel = typeof I18n !== 'undefined' ? I18n.t('search_agent.selector.from') : 'From';
      const toLabel = typeof I18n !== 'undefined' ? I18n.t('search_agent.selector.to') : 'To';

      if (lowerHandle && !lowerHandle.hasAttribute('aria-label')) {
        lowerHandle.setAttribute('aria-label', fromLabel);
      }
      if (upperHandle && !upperHandle.hasAttribute('aria-label')) {
        upperHandle.setAttribute('aria-label', toLabel);
      }
    }
  };

  handleChange = (e) =>
    this.setState({ [e.target.id]: e.target.value.replace(/\D/g, '') });

  handleKeyPress = (e, valueChangeFunc) => {
    if (e.key === 'Enter') {
      e.target.blur();
      this.handleValueChange(e, valueChangeFunc);
    }
  };

  handleBlur = (e, valueType, valueChangeFunc) => {
    const { value, employeeCalculation } = this.props;

    this.handleInputClick(e);

    this.setState({ maxInputIsFocused: false });
    e.target.value.replace(/\D/g,'') === ''
      ? (e.target.value = employeeCalculation ? Math.round(value[valueType] / 15) : value[valueType])
      : this.handleValueChange(e, valueChangeFunc);
  };

  handleValueChange = (e, valueChangeFunc) => {
    let currentState = Object.assign({}, this.props.value);
    const targetValue = +e.target.value.replace(/\D/g,'');
    const value = this.props.employeeCalculation ? targetValue * 15 : targetValue;
    const inputRange = e.target.dataset.range;

    if(value !== currentState[inputRange]) {
      currentState[inputRange] = valueChangeFunc(value, currentState);
      this.props.handleSelectorChange(currentState, true);
    }
  };

  minChange = (value, currentState) => {
    const { maxValue, minValue } = this.props;

    if(!value) {
      this.setState({ ...this.state, minInput: minValue });
      return minValue;
    } else {
      const maxLimit = value > currentState.max || value > maxValue;
      const minLimit = value < minValue ? minValue : value;
      return maxLimit ? currentState.max : minLimit;
    }
  };

  maxChange = (value, currentState) => {
    const { maxValue, minValue, allowBiggerValue } = this.props;
    const currentValue = +value;

    if(!currentValue) {
      this.setState({ maxInput: maxValue });
      return maxValue;
    } else {
      const maxLimit = currentValue > maxValue;
      const minLimit = currentValue < +currentState.min || currentValue < minValue ? +currentState.min : currentValue;
      this.setState({ maxInput: maxLimit ? (allowBiggerValue ? minLimit : maxValue) : minLimit });
      return maxLimit ? (allowBiggerValue ? minLimit : maxValue) : minLimit;
    }
  };

  onSlide = (value) => {
    this.setState({
      minInput: value[0].slice(0, -3),
      maxInput: value[1].slice(0, -3)
    });

    this.setState({
      employeeMin: Math.round(value[0].slice(0, -3) / 15),
      employeeMax: Math.round(value[1].slice(0, -3) / 15)
    })
  };

  handleChangeComplete = (value, handle) => {
    const { filterType, employeeCalculation, handleSelectorChange } = this.props;

    const min = Number(value[0].slice(0, -3));
    const max = Number(value[1].slice(0, -3));
    let currentState = Object.assign({}, this.props.value);

    if(max > this.props.maxValue) {
      currentState.max = this.props.maxValue;
    } else if(min < this.props.minValue) {
      currentState.min = this.props.minValue;
    } else {
      currentState.min = min;
      currentState.max = max;
    }

    const activeInput = handle === 0
      ? (employeeCalculation ? `employeeMin${filterType}` : `minInput${filterType}`)
      : handle === 1
        ? (employeeCalculation ? `employeeMax${filterType}` : `maxInput${filterType}`)
        : null;

    activeInput && this.setState({ activeInput });
    handleSelectorChange(currentState, true);

    if (activeInput) {
      const activeInputField = this[activeInput];
      activeInputField.classList.add('outline-none');
      activeInputField.focus();
    }
  };

  handleInputClick = (e) =>
    e.target.classList.remove('outline-none');

  handleFocus = (e) => {
    const value = e.target.value.replace(/\D/g,'');
    value === 0 || value === '0' ? e.target.value = '' : null;
  };

  handleMaxInputFocus = () =>
    this.setState({ maxInputIsFocused: true });

  render() {
    const { maxInputIsFocused, maxInput, employeeMax, employeeMin, minInput } = this.state;
    const { minValue, maxValue, dimension, employeeCalculation, noLinear, showInputLabels, showMaxMoreIcon, value, filterType } = this.props;

    const locale = I18n.locale === 'en' ? 'fr' : I18n.locale;
    const localizedNumberFormatter = (value) => new Intl.NumberFormat(locale).format(value);
    const selectedMaxValue = (!maxInputIsFocused && showMaxMoreIcon && +maxInput === maxValue) ? localizedNumberFormatter(maxInput) + ' +' : localizedNumberFormatter(maxInput);
    const selectedMaxEmployeeValue = (!maxInputIsFocused && showMaxMoreIcon && +employeeMax === Math.round(maxValue / 15)) ? localizedNumberFormatter(employeeMax) + ' +' : localizedNumberFormatter(employeeMax);
    const range = noLinear ? {'min': [0, 10], '25%': [100, 20],'50%': [400, 50], 'max': [maxValue]} : { min: 0, max: maxValue };

    return (
      // 5. Огортаємо Nouislider в div і передаємо створений ref
      <div ref={this.sliderWrapperRef} className={`input-range ${noLinear ? 'no-linear' : ''}`}>
        <div className='input-range__label'>
          <span>{I18n.t('search_agent.selector.from')}</span>
          <span>{I18n.t('search_agent.selector.to')}</span>
        </div>

        <Nouislider
          connect
          onChange={this.handleChangeComplete}
          onSlide={this.onSlide}
          range={range}
          start={[value.min, value.max]}
        />

        <form className='input-range__inputs'>
          <div className='form-group'>
            <input
              aria-label="From"
              className={`form-control ${(employeeCalculation ? employeeMin : minInput) === minValue ? 'as-placeholder' : ''}`}
              data-range="min"
              id={employeeCalculation ? `employeeMin` : `minInput`}
              inputMode="numeric"
              max={maxValue}
              min={minValue}
              onBlur={e => this.handleBlur(e, 'min', this.minChange)}
              onChange={this.handleChange}
              onClick={(e) => this.handleInputClick(e)}
              onFocus={this.handleFocus}
              onKeyPress={e => this.handleKeyPress(e, this.minChange)}
              ref={el => this[employeeCalculation ? `employeeMin${filterType}` : `minInput${filterType}`] = el}
              type='text'
              value={localizedNumberFormatter(employeeCalculation ? employeeMin : minInput)}
            />
            <span className='input-range__dimension'>{ dimension }</span>
            { showInputLabels &&
              <Fragment>
                <div className="input-range__input-label">
                  { I18n.t('generic.minimum') }
                </div>
                <div className="input-range__input-border" />
              </Fragment>
            }
          </div>

          <div className="input-range__inputs-deviders" />

          <div className="form-group">
            <input
              aria-label="To"
              className="form-control"
              data-range="max"
              id={employeeCalculation ? 'employeeMax' : 'maxInput'}
              inputMode="numeric"
              max={maxValue}
              min={minValue}
              ref={el => this[employeeCalculation ? `employeeMax${filterType}` : `maxInput${filterType}`] = el}
              onBlur={ e => this.handleBlur(e, 'max', this.maxChange)}
              onChange={this.handleChange}
              onFocus={this.handleMaxInputFocus}
              onKeyPress={e => this.handleKeyPress(e, this.maxChange)}
              type='text'
              value={employeeCalculation ? selectedMaxEmployeeValue : selectedMaxValue}
            />
            <span className='input-range__dimension'>{ dimension }</span>
            { showInputLabels &&
              <Fragment>
                <div className="input-range__input-label">
                  { I18n.t('generic.maximum') }
                </div>
                <div className="input-range__input-border" />
              </Fragment>
            }
          </div>
        </form>
      </div>
    );
  }
};

export default RangeSlider;
